
// const TIME_FORMAT = 12;
// const MINUTE_SCALE_SIZE = 2;

export default function createTime(date) {
  const messageDate = new Date(+date);
  const options = {
    hour: 'numeric',
    minute: 'numeric',
  };
  // return `${
  //   messageDate.getHours() % TIME_FORMAT === 0 ? TIME_FORMAT : messageDate.getHours() % TIME_FORMAT
  // }:${
  //   (`0${messageDate.getMinutes()}`).slice(-MINUTE_SCALE_SIZE)
  // } ${
  //   messageDate.getHours() < TIME_FORMAT ? 'AM' : 'PM'
  // }`;
  return messageDate.toLocaleTimeString(undefined, options)
}
